export const LOCAL_STORE_LANGUAGE = 'localLanguage';
export const LOCAL_STORE_TEMP = 'temp';
